import React, { useContext, useState } from 'react';
import SvgIcon from '../../../Components/Common/Component/SvgIcon';
import CustomizerContext from '../../../_helper/Customizer';
import { applyMixBackground, persistThemePreferences } from '../../../utils/themePreferences';

const MoonLight = () => {
  const { addMixBackgroundLayout } = useContext(CustomizerContext);
  const [moonlight, setMoonlight] = useState(
    () => (localStorage.getItem('mix_background_layout') || 'light-only') === 'light-only'
  );

  const MoonlightToggle = (light) => {
    const mode = light ? 'light-only' : 'dark-only';
    applyMixBackground(mode);
    addMixBackgroundLayout(mode);
    setMoonlight(light);
    void persistThemePreferences();
  };

  return (
    <li>
      <div className={`mode ${moonlight && 'active'}`} onClick={() => MoonlightToggle(moonlight)}>
        <SvgIcon iconId={'moon'} />
      </div>
    </li>
  );
};

export default MoonLight;
